// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AIkwd","clinicsSelect":"styles_clinicsSelect__3LKyX"};